import { render } from "./BtnGreen.vue?vue&type=template&id=1938196e&scoped=true"
import script from "./BtnGreen.vue?vue&type=script&lang=js"
export * from "./BtnGreen.vue?vue&type=script&lang=js"

import "./BtnGreen.vue?vue&type=style&index=0&id=1938196e&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\a-okamura\\Documents\\project\\JuchuAppFront\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1938196e"]])

export default __exports__